import { Component, ViewChild } from '@angular/core'
import { BehaviorSubject, Observable, of } from 'rxjs'
import { MatStepper } from '@angular/material/stepper'
import { BatchItemComponent } from '../batch-item/batch-item.component'
import { BatchItemViewModel } from '../../viewModels/batch-item-view-model'
import { BatchesTableFactory } from './../../factories/batches-table-factory'
import { TableDefinition, BiomaterialImportResponse } from '@plantandfood/kup.core'
import { BiomaterialCombImportResponse } from 'biomaterial-batches/models/biomaterial-comb-import-response.model'

@Component({
    selector: 'pfr-create-batch-item',
    templateUrl: './create-batch-item.component.html',
    styleUrls: ['./create-batch-item.component.scss'],
    providers: [BatchItemViewModel, BatchesTableFactory],
})
export class CreateBatchItemComponent {
    private readonly _processing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
    public readonly processing$: Observable<boolean> = this._processing.asObservable()

    private readonly _isSuccess: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
    public readonly isSuccess$: Observable<boolean> = this._isSuccess.asObservable()

    tableDefinition: TableDefinition = BatchesTableFactory.batchBiomaterials()
    tableData$: Observable<any[]>
    isSuccess: boolean
    @ViewChild(BatchItemComponent, { static: true })
    batchItem: BatchItemComponent

    onVerified(response: any) {
        this._toggleProcessing(false)
        if ((this.batchItem.formFactory.form.value as any).Radio === 'withBiomaterial') {
            const tableData: BiomaterialImportResponse[] = response.results
            this.tableData$ = of(tableData)
            this.tableDefinition = BatchesTableFactory.batchBiomaterials()
        } else if ((this.batchItem.formFactory.form.value as any).Radio === 'combBiomaterial') {
            const combTableData: BiomaterialCombImportResponse[] = response.results
            this.tableData$ = of(combTableData)
            this.tableDefinition = BatchesTableFactory.batchCombBiomaterials()
        }

        if (response.status === 'SUCCESS' || response.status === 'WARNING') {
            this._isSuccess.next(false)
        } else {
            this._isSuccess.next(true)
        }
    }

    OnTolistView() {
        this.batchItem.viewModel.toListView()
    }

    async onCreateBatch(validate: boolean, stepper: MatStepper) {
        this._toggleProcessing(true)
        await this.batchItem.onUploadBatchFile(validate, stepper)
    }

    async createEmptyBatch() {
        this._toggleProcessing(true)
        await this.batchItem.createBatchWithNoBiomaterial()
        this._toggleProcessing(false)
    }

    private _toggleProcessing(processing?: boolean): void {
        if (processing !== null || processing !== undefined) {
            this._processing.next(processing)
            this._isSuccess.next(processing)
            return
        }

        const current = this._processing.getValue()
        this._processing.next(!current)
    }
}
